module.exports = __webpack_public_path__ + "img/stimulate.742a0b46.png";